import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';
import { format } from "d3-format"
import CardMicrobiome from '../../../../components/Cards/CardMicrobiome';
import StatusInfo from "./StatusInfo"
import DiaOverview from './DiaOverview';

import GetMicro_2 from "./GetMicro_2";
import MicroBarChart from "./MicroBarChart";
import { Card } from '@mui/material';

const micro_warning_low = 153;
const micro_warning_red = 115;


export default function MicroCard(data) {

const diversity = data.data


return (
<>
<CardMicrobiome
  
content = {<>      

   <Grid container >  

      <Grid item xs={4} > 
              
            <Grid container >   
            
                <Grid container >   
                        <Grid item xs={10}> <Typography variant="h3" color='common.white' sx={{p:1}}> MICROBIOME&nbsp; OVERVIEW&nbsp; </Typography>  </Grid>
                        <Grid item xs={2}> <StatusInfo />   </Grid>
                </Grid>
                
                <Grid item xs={12} sx={{ p:1 }} >

                          <Typography   variant="h3" color='primary.light' 
                                        sx={{fontFamily: 'Poppins', fontWeight: '400', fontSize: {sx: '55%', sm: '45%', md: '175%', lg: '180%', xl: '300%' },
                                                
                                              color: 'traffic.green', 
                                              ...(diversity < micro_warning_low && {color: 'traffic.orange'}), 
                                              ...(diversity < micro_warning_red && {color: 'traffic.red'}), 
                                              }}> 
                                      
                                      {format(",")(diversity )}&nbsp;<Typography component="span" variant="body1"> species </Typography><br />
                                      
                          </Typography>

                </Grid>

     <Grid item xs={12} sx={{ pl:1 }} > 
            <Typography variant='h6 'sx={{ color: 'common.white', fontFamily: 'Poppins', fontWeight: '200', fontSize: '0.8rem'}} >
            Reference:  &nbsp;SPECIES 150 {'-'} 340
        </Typography>
    </Grid>

                <Grid item xs={12} sx={{ pl:1, pt:4 }}>  

                          <Typography variant="h3" color='primary.light' 
                                        sx={{ fontWeight: '400', fontSize: {sx: '55%', sm: '45%', md: '175%', lg: '180%', xl: '160%' }, }}> 
                               Entero Type  &nbsp;&nbsp; 1

                          </Typography>
                </Grid>

                 <Grid item xs={12} sx={{ p:0 }} >
                                
                 </Grid>     
                    
          </Grid>
      </Grid>

    <Grid item xs={4} sx={{ alignItems: 'center', justifyContent: 'center',  }}> <GetMicro_2 />  </Grid> 

    <Grid item xs={4} sx={{pl:4, pt:2,  alignItems: 'center', justifyContent: 'center', }}> <MicroBarChart />  </Grid> 

</Grid>
 
           
        </>}   
    />    
    </>
    )};
  